$(document).ready(function () {
  $(".registration-tip-popover").popover();

  $("#result2").hide();
  
  let emptyDialog = $("#dialog_empty");
  let auditDialog = $("#dialog_aud");
  let passNoPassDialog = $("#dialog_PassNP");
  
  emptyDialog.hide();
  auditDialog.hide();
  passNoPassDialog.hide();
  emptyDialog.dialog({ autoOpen: false });
  auditDialog.dialog({ autoOpen: false });
  passNoPassDialog.dialog({ autoOpen: false });

  $("div#mycbdiv").removeClass("hidden");

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".scrollup").fadeIn();
    } else {
      $(".scrollup").fadeOut();
    }
  });

  $(".scrollup").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600
    );
    return false;
  });

  $("div#deptdiv").removeClass("hidden");
});

window.procUnitChange = function (param1) {
  $("#unitsel_" + param1).submit();
};

window.OnComplGrdOptChgReq = function (param1) {
  if (
    document.getElementById("goresult-aud-" + param1).innerHTML === "Updated-V"
  ) {
    let width = screen.width / 2;
    let height = screen.height / 2;

    let auditDialog = $("#dialog_aud");

    auditDialog.dialog({
      buttons: [
        {
          text: "Ok",
          click: function () {
            $(this).dialog("close");
          },
        },
      ],
    });
    auditDialog.dialog("option", "maxHeight", height);
    auditDialog.dialog("option", "maxWidth", width);
    auditDialog.dialog("open");
  }

  if (
    document.getElementById("goresult-aud-" + param1).innerHTML === "Updated-PN"
  ) {
    let width = screen.width / 2;
    let height = screen.height / 2;

    let passNoPassDialog = $("#dialog_PassNP");

    passNoPassDialog.dialog({
      buttons: [
        {
          text: "Ok",
          click: function () {
            $(this).dialog("close");
          },
        },
      ],
    });
    passNoPassDialog.dialog("option", "maxHeight", height);
    passNoPassDialog.dialog("option", "maxWidth", width);
    passNoPassDialog.dialog("open");
  }
};

window.procGrdOptChange = function (param1) {
  $("#grdoptsel_" + param1).submit();
};

window.procGrdOptChgReqq = function (param1) {
  $("#grdoptchgreq_" + param1).submit();
};

window.procschedNregN = function (param1) {
  $("#schedY_regN_" + param1).hide();
  $("#schedN_regN_" + param1).show();
  $("#schedY_regY_" + param1).hide();
  $("#schedN_regY_" + param1).hide();

  $("#schedY_regN_status_" + param1).hide();
  $("#schedN_regN_status_" + param1).show();
  $("#schedY_regY_status_" + param1).hide();
  $("#schedN_regY_status_" + param1).hide();
};
window.procschedYregN = function (param1) {
  $("#schedY_regN_" + param1).show();
  $("#schedN_regN_" + param1).hide();
  $("#schedY_regY_" + param1).hide();
  $("#schedN_regY_" + param1).hide();

  $("#schedY_regN_status_" + param1).show();
  $("#schedN_regN_status_" + param1).hide();
  $("#schedY_regY_status_" + param1).hide();
  $("#schedN_regY_status_" + param1).hide();
};

window.procschedNregY = function (param1) {
  $("#schedY_regN_" + param1).hide();
  $("#schedN_regN_" + param1).hide();
  $("#schedY_regY_" + param1).hide();
  $("#schedN_regY_" + param1).show();

  $("#schedY_regN_status_" + param1).hide();
  $("#schedN_regN_status_" + param1).hide();
  $("#schedY_regY_status_" + param1).hide();
  $("#schedN_regY_status_" + param1).show();
};

window.procschedYregY = function (param1) {
  $("#schedY_regN_" + param1).hide();
  $("#schedN_regN_" + param1).hide();
  $("#schedY_regY_" + param1).show();
  $("#schedN_regY_" + param1).hide();

  $("#schedY_regN_status_" + param1).hide();
  $("#schedN_regN_status_" + param1).hide();
  $("#schedY_regY_status_" + param1).show();
  $("#schedN_regY_status_" + param1).hide();
};

window.procRmv = function (param1) {
  document.getElementById("section_" + param1).innerHTML =
    "The section has been removed";
  
  let section = $("#section_" + param1);

  section.addClass("col-xs-12 col-sm-12 col-md-12 col-lg-12");
  section.css("padding", "0");
  section.css("font-size", "1.2rem");

  $("#schedY_regN_" + param1).hide();
  $("#schedN_regN_" + param1).hide();
};

window.onAjaxLinkClick = function(linkElement) {
  $(linkElement).addClass('ajax-link-disabled');
}

window.onAjaxLinkComplete = function(linkElement, sectionId, actionName) {
  $(linkElement).removeClass('ajax-link-disabled');
  
  switch (actionName) {
    case 'procschedNregN':
      procschedNregN(sectionId);
      break;
    case 'procschedYregN':
      procschedYregN(sectionId);
      break;
    case 'procRmv':
      procRmv(sectionId);
      break;
    case 'procschedNregY':
      procschedNregY(sectionId);
      break;
    case 'procschedYregY':
      procschedYregY(sectionId);
      break;
    default:
      console.log('No action defined for this link.');
  }
}